import { render, staticRenderFns } from "./CardPeriod.vue?vue&type=template&id=20d27dbb&"
import script from "./CardPeriod.vue?vue&type=script&lang=js&"
export * from "./CardPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports